import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CargaArchivoService } from '../../service/carga-archivo.service';
import { PanelBulkLoadComponent } from '../shared/panel-bulk-load.component';
import { BulkLoadType } from '../../enums/bulk-load-type.enum';

const excelTemplate = '/assets/files/Carga_masiva-status_person.xlsx';
const fileTitle = 'Carga masiva - Personas y estados.xlsx';

@Component({
  selector: 'app-bulk-load-status-person',
  templateUrl: '../shared/panel-bulk-load.component.html',
  styleUrls: ['./bulk-load-status-person.component.css'],
})
export class BulkLoadStatusPersonComponent extends PanelBulkLoadComponent {
  title = 'Carga de personas y estados';
  bulkLoadType = BulkLoadType.STATUS_PERSON;

  loadRegisterSpinner = false;
  fileLoaded = false;
  fileSelected = true;

  markListFile: any;

  fileName: string;
  format: string;
  urlGenerated: string;
  messageModal: string;
  modalTitle: string;

  loadResultData: any;

  constructor(
    public readonly cargaArchivoService: CargaArchivoService,
    public readonly http: HttpClient
  ) {
    super(cargaArchivoService, http, excelTemplate, fileTitle);
  }

  // carga de documentos a S3
  public loadRegisterFile() {
    this.loadRegisterSpinner = true;
    this.cargaArchivoService
      .getPreSignUploadFile(this.format)
      .subscribe(fileUrl => {
        this.urlGenerated = fileUrl;

        this.cargaArchivoService
          .loadFileToUrl(fileUrl, this.markListFile)
          .subscribe(() => {
            const urlFinal = this.urlGenerated.split('?')[0];

            this.cargaArchivoService
              .loadDataFromfile(urlFinal, this.format, this.bulkLoadType)
              .subscribe(processId => {
                this.modalFileLoad.show();
                this.loadExecutionProcessFile(processId);
              });
          });
      });
  }
}
